import { ILLUSTRATED_MARKERS } from './illustrated-markers.js';
import type { SchemaInput } from './schema-input.js';
import { isString } from './runtime-values.js';
export const MARKER_ICON_NAMES = [
  'map-pin', 'star', 'flag', 'camera', 'heart', 'info', 'circle-alert', 'fuel', 'trees',
  'house', 'hospital', 'shopping-cart', 'utensils', 'coffee', 'bed', 'plane', 'car',
  'circle-parking', 'ship', 'bike', 'mountain', 'waves', 'tent-tree', 'landmark',
  ...ILLUSTRATED_MARKERS.map(marker => marker.name),
  // Kept for shared maps that used the old visible ellipsis marker.
  'ellipsis',
] as const;

export type MarkerIconName = typeof MARKER_ICON_NAMES[number];

export function isMarkerIconName(value: SchemaInput): value is MarkerIconName {
  // SAFETY: The adjacent array check validates the collection and its elements before use.
  return isString(value) && (MARKER_ICON_NAMES as readonly string[]).includes(value);
}
